import { render, staticRenderFns } from "./LBanner.vue?vue&type=template&id=13d901f4&scoped=true&"
import script from "./LBanner.vue?vue&type=script&lang=js&"
export * from "./LBanner.vue?vue&type=script&lang=js&"
import style0 from "./LBanner.vue?vue&type=style&index=0&id=13d901f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d901f4",
  null
  
)

export default component.exports